<template>
  <v-container fluid>
    <v-row>
      <v-col class="col-12">
        <h1>
          Weekly timesheets report for Week {{ week }} {{ year }} starting {{ startDate | tinyDate }}
          <v-btn
              @click="showPicker = true"
              class="float-right"
              small>View calendar</v-btn>
          <v-btn
              @click="changeWeek(2)"
              class="float-right ml-2 mr-2"
              small>Next Week</v-btn>
          <v-btn
              @click="changeWeek(1)"
              class="float-right ml-2"
              small>Prev Week</v-btn>
          <v-btn
            @click="exportTimesheets(true)"
            class="float-right"
            small>
            Export</v-btn>
        </h1>
      </v-col>
    </v-row>
    <v-row v-if="showPicker">
      <v-col>
        <v-date-picker v-model="weekDate"></v-date-picker>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-simple-table
            fixed-header
            height="450px"
        >
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">Name</th>
              <th class="text-left">Job Number</th>
              <th class="text-left">Notes</th>
              <th class="text-left">Date</th>
              <th class="text-left">Start Time</th>
              <th class="text-left">End Time</th>
              <th class="text-left">Time Recorded</th>
              <th class="text-left">Checked</th>
              <th class="text-left">Office Notes</th>
              <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(sheet, index) in timesheets"
                :key="index"
            >
              <td>{{ sheet.name }}</td>
              <td><v-text-field v-model="sheet.job_number"/></td>
              <td><v-text-field v-model="sheet.notes" /></td>
              <td><v-text-field v-model="sheet.prettyDate" /></td>
              <td><v-text-field v-model="sheet.start_time" /></td>
              <td><v-text-field v-model="sheet.end_time" /></td>
              <td><v-text-field v-model="sheet.timeRecorded" /></td>
              <td>
                <v-checkbox @change="toggleChecked(index)" :ripple="false"  v-model="sheet.checked"></v-checkbox>
              </td>
              <td>
                <v-text-field v-model="sheet.office_notes" />
              </td>
              <td>
                <v-btn
                  x-small
                  color="green"
                  @click="updateTimesheet(index)">
                  Save Changes
                </v-btn>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from '../../../axios';

export default {
  name: 'AdminTimesheetsIndex',
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      timesheets: [],
      showPicker: false,
      week: 0,
      year: 0,
      weekDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      startDate: null,
    };
  },
  watch: {
    weekDate() {
      this.showPicker = false;
      this.updateWeek();
    },
  },
  methods: {
    exportTimesheets() {
      axios.post(`/spreadsheets/timesheets.json?token=${this.token}`, this.startDate, {responseType:'blob'})
          .then((response) => {
            const href = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'timesheets.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          });
    },
    getTimesheets() {
      const day = this.startDate.getDate();
      const month = (this.startDate.getMonth() + 1);
      const year = this.startDate.getFullYear();
      const date = `${year}-${month}-${day}`;
      axios.post(`/timesheets/getAll.json?token=${this.token}`, date)
        .then((response) => {
          this.timesheets = response.data.timesheets;
          this.length = response.data.length;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    changeWeek(direction) {
      if (direction === 1) {
        if (this.week > 1) {
          this.week = parseInt(this.week) - 1;
        } else {
          this.week = 52;
          this.year = parseInt(this.year) - 1;
        }
      } else {
        if (this.week < 52) {
          this.week = parseInt(this.week) + 1;
        } else {
          this.week = 1;
          this.year = parseInt(this.year) + 1;
        }
      }
      const d = (1 + (this.week - 1) * 7);
      const date = new Date(this.year, 0, d);
      this.startDate = this.getMonday(date);
      this.getTimesheets();
    },
    getMonday(d) {
      d = new Date(d);
      let day = d.getDay();
      const diff = d.getDate() - day + (day === 0 ? -6 : 1);
      return new Date(d.setDate(diff));
    },
    updateTimesheet(index) {
      const timesheet = this.timesheets[index];
      axios.post(`/timesheets/updateSingle.json?token=${this.token}`, timesheet);
    },
    updateWeek() {
      this.week = this.getWeek(new Date(this.weekDate));
      const currentDate = new Date(this.weekDate);
      this.year = currentDate.getFullYear();
      this.startDate = this.getMonday(currentDate);
      this.getTimesheets();
    },
    getWeek(date) {
      if (!(date instanceof Date)) date = new Date();
      const nDay = (date.getDay() + 6) % 7;
      date.setDate(date.getDate() - nDay + 3);
      const n1stThursday = date.valueOf();
      date.setMonth(0, 1);
      if (date.getDay() !== 4) {
        date.setMonth(0, 1 + ((4 - date.getDay()) + 7) % 7);
      }
      return 1 + Math.ceil((n1stThursday - date) / 604800000);
    },
    toggleChecked(index) {
      const id = this.timesheets[index].id;
      axios.get(`/timesheets/toggleChecked/${id}.json?token=${this.token}`);
    },
  },
  mounted() {
    this.updateWeek();
  },
};
</script>
